import type { ButtonProps } from "./interface";
import { useButton } from "./useButton";

export function Button({
  children,
  variant = "primary",
  size = "large",
  ...props
}: ButtonProps) {
  const { buttonStyle } = useButton({ variant, ...props });

  return (
    <button
      className={`${
        size === "medium"
          ? "px-4 py-1 h-10"
          : size === "small"
          ? "px-2 py-1 text-[12px]"
          : "px-6 py-3"
      } ${buttonStyle} rounded-lg transition-colors duration-200 w-full`}
      {...props}
    >
      {children}
    </button>
  );
}
